import React from 'react';

import { Footer, Header, PageLayout } from '../../components';
import PageContent from '../../features/Merchandise';

const MerchandisePage = () => {
  return (
    <>
      <Header />
      <PageLayout>
        <PageContent />
      </PageLayout>
      <Footer />
    </>
  );
};

export default MerchandisePage;
